import React from 'react';

import { EnvelopeSimple } from 'components/shared/Icon/phosphorIcons';
import Loader from 'components/shared/Loader';
import Text from 'components/shared/Typography/Text';

import { useVerify } from './functions';
import s from './index.module.css';

function SendVerification() {
  const { verifyMutation } = useVerify();

  return (
    <div>
      <div className={s.successful}>
        {verifyMutation.isLoading && <Loader isFillBlock />}
        <EnvelopeSimple size={60} weight="thin" />
        <div className={s.titleWrapper}>
          <Text isStrong className={s.title}>
            Check Your Email
          </Text>
        </div>
        <div>
          <Text>
            Please click the verification link
            <br /> from your email inbox
          </Text>
        </div>
        <div className={s.buttonWrapper}>
          <div onClick={() => verifyMutation.mutate()} className={s.button}>
            Resend
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendVerification;
